import { TOUR_ACTIONS } from "./tourActions";

const initialState = {
  completedTours: [], // ['dashboard', 'opac', 'profile']
  showWelcomeModal: false,
  activeTour: null,
  isNewUser: false,
};

export const tourReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOUR_ACTIONS.SET_TOUR_STATUS: {
      const { tourType, isCompleted } = action.payload;
      return {
        ...state,
        completedTours: isCompleted
          ? [...state.completedTours, tourType]
          : state.completedTours.filter((t) => t !== tourType),
      };
    }

    case TOUR_ACTIONS.SET_WELCOME_MODAL:
      return {
        ...state,
        showWelcomeModal: action.payload,
      };

    case TOUR_ACTIONS.SET_ACTIVE_TOUR:
      return {
        ...state,
        activeTour: action.payload,
      };

    default:
      return state;
  }
};
